












import { ContentLoader, BaseComponent } from '@tencent/wphk-components-content-loader';
import { defineComponent } from '@vue/composition-api';
export default defineComponent({
  name: 'TncSkeleton',
  props: {
    isReady: Boolean,
  },
  components: {
    ContentLoader,
    BaseComponent,
  },
});
